import * as React from 'react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { observer } from 'mobx-react';
import TopThumbnail from './images/thumbnail-top.png';
import TopThumbnailSp from './images/thumbnail-top-sp.png';
import { TopSection } from '../../components/organisms/migration/TopSection';
import { ChangeSummarySection } from '../../components/organisms/migration/ChangeSummarySection';
import './migrationPage.module.scss';
import { BenefitSection } from '../../components/organisms/migration/BenefitSection';
import { MigrationSection } from '../../components/organisms/migration/MigrationSection';
import { NoteSection } from '../../components/organisms/migration/NoteSection';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { PricingSection } from '../../components/organisms/migration/PricingSection';
import { DeadlineSection } from '../../components/organisms/migration/DeadlineSection';
import { FaqSection } from '../../components/organisms/migration/FaqSection';

export const MigrationPage = withNavigation(NavigationSpecs.standard())(
  observer(
    class MigrationPage extends React.Component {
      render() {
        const mobile = GlobalStatesV3.viewport.isMobile;
        return (
          <div styleName="page">
            <img styleName="top-thumbnail" src={mobile ? TopThumbnailSp : TopThumbnail} />
            <div styleName="body">
              <TopSection />
              <ChangeSummarySection />
              <PricingSection />
              <BenefitSection />
              <MigrationSection />
              <DeadlineSection />
              <NoteSection />
              <FaqSection />
            </div>
          </div>
        );
      }
    }
  )
);
